module.exports = __webpack_public_path__ + "img/q_bg.8ce6eeb8.png";